<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>
    <span class="a-color-picker">
      <a
        id="previewColor"
        href="#"
        @click.stop.prevent="toggleColorPickerVisibility"
      >
      </a>
      <input
        id="inputColor"
        value=""
        v-bind="$attrs"
        v-on="listeners"
        :class="$v.colorPicked.$error ? `a-input-primary a-input-danger ${inputClass}` : `a-input-primary ${inputClass}`"
        spellcheck="false"
        @click.stop.prevent="showColorPickerVisibility"
        @focus="showColorPickerVisibility($event) ; $v.colorPicked.$touch($event)"
        @input="updateValue"
      />
    </span>
    <small
      v-if="$v.colorPicked.$error"
      class="text-color-danger"
    >
      {{ messageErrorColorPicked }}
    </small>
    <ColorPicker
      id="colorPicker"
      v-model="colorPicked"
      v-show="showColorPicker"
    />
  </p>
</template>

<script>

import { Chrome } from 'vue-color'
import { maxLength, minLength } from 'vuelidate/lib/validators'

const numHexadecimal = value => {
  return value === '' ? true : /^#[0-9A-F]+$/ig.test(value)
}

export default {
  name: 'AtomColorPicker',

  components: {
    'ColorPicker': Chrome
  },

  inheritAttrs: false,

  props: {
    color: String,
    inputClass: String,
    inputError: Boolean,
    label: String,
    message: String,
    messageError: String,
    wrapperClass: String
  },

  data () {
    return {
      colorPicked: '',
      showColorPicker: false
    }
  },

  validations: {
    colorPicked: {
      maxLength: maxLength(7),
      minLEngth: minLength(7),
      numHexadecimal
    }
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    },

    messageErrorColorPicked () {
      return this.$validation.getValidationMessage('aColorPicker', this.$v.colorPicked, 'colorPicked')
    }
  },

  watch: {
    color () {
      this.colorPicked = this.color
    },

    colorPicked () {
      let cp = this.colorPicked.hex ? this.colorPicked.hex : this.colorPicked
      document.getElementById('inputColor').value = cp
      document.getElementById('previewColor').style.backgroundColor = cp
      this.colorPicked = cp
      !this.$v.$error ? this.$emit('changeColor', cp) : this.$emit('errorColor', true)
    }
  },

  created () {
    this.colorPicked = this.color
  },

  updated () {
    document.addEventListener('click', e => {
      var isClickInside = document.getElementById('colorPicker').contains(e.target)
      if (!isClickInside) {
        this.showColorPicker = false
      }
    })
  },

  methods: {
    showColorPickerVisibility () {
      this.showColorPicker = true
    },

    toggleColorPickerVisibility () {
      this.showColorPicker = !this.showColorPicker
    },

    updateValue (event) {
      this.colorPicked = event.target.value.toUpperCase()
    }
  }
}
</script>
